import service from 'utils/request'
const urlObj = {
  users:  "/sys/emapflow/usergroup/getUsers.do",
  dept: "/sys/emapflow/modules/elecseal/deptQuery.do",
  searchDeptStaff: "/sys/emapflow/modules/deptjzg/jzgQuery.do",
  deptStaff: "/sys/emapflow/modules/elecseal/jzgQuery.do"
}

const getUsers = (params) => {
  return service({
    url: urlObj.users,
    params: params
  })
}

const getDeptQuery = () => {
  return service({
    url: urlObj.dept
  })
}

const getSearchStaff = (data) => {
  return service({
    url: urlObj.searchDeptStaff,
    method: 'post',
    data: data
  })
}


const getDeptStaff = (data) => {
  return service({
    url: urlObj.deptStaff,
    method: 'post',
    data: data
  })
}

const api = {
  getUsers, getDeptQuery, getDeptStaff, getSearchStaff
}

export {
  getUsers, getDeptQuery, getDeptStaff, getSearchStaff
}

export default api